import React, { Component } from 'react'
import './GeomConvert.scss';
import { Input, Button,Checkbox, message } from 'antd';
import { ArrowRightOutlined, ArrowLeftOutlined,CopyOutlined,DownloadOutlined,SendOutlined } from '@ant-design/icons';
import { geometryUtil } from './../../util/geometryUtil'
import context from '../../context';
import MapWidgetUI from '../../components/MapWidgetUI';
import GeomConvert from './GeomConvert';
import GeomDiff from './GeomDiff';
const { TextArea } = Input;
const { Search } = Input;

export default class ConverterMain extends Component {
  map = null;
  constructor(props) {
    super(props)
    this.state = {
      latLng:null,
    }
  }
  _onLatLng = (value) => {
    this.setState({ latLng: value });
  }

  _onAddLayer = (coordinates,geomStyle) => {
    this.map.locatedPolygon(coordinates,geomStyle);
  }

  _onAddPoint = (coordinates) => {
    this.map.locatedPoint(coordinates);
  }

  render() {
    const { } = this.state;
    return <div className="converter-main">
      <GeomConvert latLng={this.state.latLng} onAddLayer={this._onAddLayer} onAddPoint={this._onAddPoint}/>
      <div className="geom-map" style={{width:'100%',height:'300px'}}>
        <MapWidgetUI ref={ref =>this.map = ref} onLatLng={this._onLatLng}/>
      </div>
      <GeomDiff onAddLayer={this._onAddLayer}/>
    </div>
  }
}